import { useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const RAW = process.env.REACT_APP_API_BASE || "";
const API_BASE = RAW.replace(/\/+$/, "");
const APIv1 = API_BASE.endsWith("/api") ? API_BASE : `${API_BASE}/api`;

export default function DealerChangePassword() {
  const navigate = useNavigate();
  const token = useMemo(() => localStorage.getItem("dealerToken") || "", []);
  const [currentPw, setCurrentPw] = useState("");
  const [newPw, setNewPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [showCurr, setShowCurr] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConf, setShowConf] = useState(false);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  const strong = newPw.length >= 8;
  const match = newPw && confirm && newPw === confirm;

  const submit = async (e) => {
    e.preventDefault();
    if (!strong || !match) return;
    setLoading(true);
    setErr("");
    setMsg("");
    try {
      const res = await fetch(`${APIv1}/dealer/auth/change-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ currentPassword: currentPw, newPassword: newPw })
      });
      if (!res.ok) {
        const t = await res.text();
        throw new Error(t || `HTTP ${res.status}`);
      }
      setMsg("Password updated.");
      alert("Password updated");
      setCurrentPw(""); setNewPw(""); setConfirm("");
    navigate("/dealer/leads", { replace: true });
    } catch (e) {
      setErr(e.message || "Could not change password.");
    } finally {
      setLoading(false);
    }
  };

  const Eye = ({ on, toggle }) => (
    <button type="button" onClick={toggle} className="absolute inset-y-0 right-0 px-3 text-gray-500 hover:text-gray-700" tabIndex={-1}>
      {on ? "🙈" : "👁️"}
    </button>
  );

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <form onSubmit={submit} className="w-full max-w-md bg-white border rounded-xl p-6">
        <h1 className="text-2xl font-semibold">Change password</h1>

        <label className="block text-sm text-gray-700 mt-4 mb-1">Current password</label>
        <div className="relative">
          <input
            type={showCurr ? "text" : "password"}
            className="w-full border rounded-lg px-3 py-2 pr-10"
            value={currentPw}
            onChange={(e) => setCurrentPw(e.target.value)}
            required
            autoComplete="current-password"
          />
          <Eye on={showCurr} toggle={() => setShowCurr(s => !s)} />
        </div>

        <label className="block text-sm text-gray-700 mt-3 mb-1">New password</label>
        <div className="relative">
          <input
            type={showNew ? "text" : "password"}
            className={`w-full border rounded-lg px-3 py-2 pr-10 ${strong ? "border-gray-300" : "border-red-300"}`}
            value={newPw}
            onChange={(e) => setNewPw(e.target.value)}
            placeholder="At least 8 characters"
            required
            autoComplete="new-password"
          />
          <Eye on={showNew} toggle={() => setShowNew(s => !s)} />
        </div>

        <label className="block text-sm text-gray-700 mt-3 mb-1">Confirm new password</label>
        <div className="relative">
          <input
            type={showConf ? "text" : "password"}
            className={`w-full border rounded-lg px-3 py-2 pr-10 ${match || !confirm ? "border-gray-300" : "border-red-300"}`}
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
            autoComplete="new-password"
          />
          <Eye on={showConf} toggle={() => setShowConf(s => !s)} />
        </div>
        {!match && confirm && <div className="text-sm text-red-600 mt-1">Passwords do not match.</div>}

        {err && <div className="text-red-600 text-sm mt-3">{err}</div>}
        {msg && <div className="text-green-700 text-sm mt-3">{msg}</div>}

        <button
          type="submit"
          disabled={!strong || !match || loading}
          className="mt-4 w-full bg-blue-600 text-white rounded-lg px-4 py-2 hover:bg-blue-700 disabled:opacity-50"
        >
          {loading ? "Updating…" : "Update password"}
        </button>

        <div className="text-sm text-gray-600 mt-4 text-center">
          <Link className="text-blue-600 underline" to="/dealer/leads">Back to Dealer Home</Link>
        </div>
      </form>
    </div>
  );
}
